import { reportApi } from '@/api/reportApi';
import ActionButton from '@/components/actions/actionButton';
import { UserSelect } from '@/components/form/userSelect';
import useSearchParam from '@/hooks/useSearchParams';
import { Group, Modal, Stack } from '@mantine/core';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { t } from 'translations';

export const Route = createFileRoute('/_auth/_home/report/export')({
    component: RouteComponent,
});

function RouteComponent() {
    const [regenerate] = useSearchParam({ from: '/_auth/_home/report/export', key: 'regenerate' });
    const navigate = useNavigate();
    const [userId, setUserId] = useState<string | null>(null);

    async function ok() {
        const reqId = await reportApi.requestReport({
            regenerate,
            filter: {
                userId,
            },
        });

        navigate({ to: '/report/$reqId', params: { reqId } });
    }

    function close() {
        navigate({ to: '/report' });
    }

    return (
        <Modal opened onClose={close} centered title={t('report.request.pleaseSelect')}>
            <Stack
                gap="md"
                p="md"
                pos="relative"
                css={{
                    width: 400,
                }}
            >
                <UserSelect
                    value={userId}
                    onChange={setUserId}
                    label={t('report.request.user')}
                    clearable
                />

                <Group justify="flex-end" gap="sm">
                    <ActionButton onClick={ok}>{t('ok')}</ActionButton>
                </Group>
            </Stack>
        </Modal>
    );
}
